export default __webpack_public_path__ + "static/media/question-mark.089bd7bf.svg";